// src/pages/ForgotPassword.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase'; // Adjust path if necessary

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError('');
    setResetMessage('');
    if (!email) {
      setError('Please enter your email address to reset your password');
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setResetMessage('Password reset email has been sent. Please check your inbox.');
    } catch (err) {
      setError('Error sending password reset email. Please check the email address or try again later.');
    }
  };

  return (
    <div>
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
          <h2 className="text-2xl font-bold mb-4 text-center text-primary">Forgot Password</h2>
          {error && <p className="text-red-500 mb-4">{error}</p>}
          {resetMessage && <p className="text-green-500 mb-4">{resetMessage}</p>}
          <form onSubmit={handleForgotPassword}>
            <div className="mb-4">
              <label htmlFor="email" className="block font-medium text-neutral mb-2">
                Email
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-secondary"
                required
              />
            </div>
            <button
              type="submit"
              className="w-full bg-primary text-white font-bold py-2 px-4 rounded-md hover:bg-secondary transition"
            >
              Send Password Reset Email
            </button>
          </form>
          <p className="mt-4 text-center text-neutral">
            Remembered your password?{' '}
            <a href="/login" className="text-secondary hover:underline">
              Login
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
